<template>
  <a
    class="uk-flex uk-flex-middle uk-text-bold"
    data-uk-toggle="target: #sizeChartModal"
    @click="setCurrentProduct(product)"
  >
    <img
      src="@/web/img/brand/size-icon.svg"
      style="height: 20px; margin-right: 8px; width: 20px"
      data-uk-svg
      alt="Icon size"
    />
    <span class="uk-text-small">Size guide</span>
    <ProductSizeChartModal :csrf="csrf" :route="route" />
  </a>
</template>

<script>
import { mapMutations } from 'vuex'

import ProductSizeChartModal from './ProductSizeChartModal.vue'

export default {
  name: 'SizeChartButton',
  components: { ProductSizeChartModal },
  props: {
    product: {
      type: Object,
      default: () => {},
    },
    route: {
      type: String,
      default: '',
    },
    csrf: {
      type: String,
      required: true,
    },
  },
  methods: {
    ...mapMutations('basket', ['setCurrentProduct']),
  },
}
</script>
